import { Link, Navigate, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { get, post } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import { decryptData } from "../_services/encDnc";
import { ClipLoader } from 'react-spinners';
import Layout from "./Shared/Layout";
import { useDispatch } from "react-redux";
import { syncCartAfterLogin } from "../redux/action";

const UserRegister = () => {
    const dispatch = useDispatch();
    const loginId = localStorage.getItem("loginId");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userAddress, setUserAdderss] = useState([]);
    const MobileNumber = sessionStorage.getItem('MobileNo');

    const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail'));
    const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
    const priviousUrl = sessionStorage.getItem('priviousUrl');

    const [formData, setFormData] = useState({
        Name: '',
        EmailId: '',
        MobileNo: MobileNumber ? MobileNumber : '',
        Password: '123',
        ConfirmPassword: '123',
        CreatedBy: 0,
        RoleId: 1
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(pervState => ({
            ...pervState,
            [name]: value
        }));

    };

    const validateName = (name) => {
        const isValid = /^[a-zA-Z\s]{2,50}$/.test(name);
        return isValid;
    };

    const validateEmail = (email) => {
        const isValid = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email);
        return isValid;
    };

    const validatePhoneNumber = (phone) => {
        const isValid = /^\d{10}$/.test(phone) && /^[0-9]/.test(phone);
        return isValid;
    };

    const onRegister = async (e) => {
        e.preventDefault();

        if (!validateName(formData.Name)) {
            toast.error('Please enter Name');
            return;
        }

        if (!validateEmail(formData.EmailId)) {
            toast.error('Please enter a valid Email Address');
            return;
        }

        if (!validatePhoneNumber(formData.MobileNo)) {
            toast.error('Please enter a valid mobile number');
            return;
        }

        const formattedMobileNo = `${formData.MobileNo}`;

        const dataToSubmit = {
            ...formData,
            MobileNo: formattedMobileNo
        };

        try {
            setLoading(true)
            const response = await post(API_URL.SaveLoginDetail, dataToSubmit, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
            if (response.isSuccess === 200) {
                toast.success('Registration successful!');
                const encryptedData = response?.data;

                const parseData = decryptData(encryptedData);
                const jwtToken = response?.token;
                localStorage.setItem('jwtToken', jwtToken);
                const { loginId } = parseData;
                localStorage.setItem('loginId', loginId);
                localStorage.setItem('isLoggedIn', true);

                setFormData({
                    Name: '',
                    EmailId: '',
                    MobileNo: '',
                    Password: '123',
                    ConfirmPassword: '123',
                });
                sessionStorage.removeItem('MobileNo');

                if (existingItemDetails) {
                    if (priviousUrl) {
                        navigate(`${priviousUrl}`);
                    } else {
                        if (userAddress.length > 0) {
                            navigate("/checkout");
                        } else {
                            navigate("/shipping-address");
                        }
                    }
                } else if (localCartData.length > 0 && localCartData != null) {
                    dispatch(syncCartAfterLogin());
                    if (priviousUrl) {
                        navigate(`${priviousUrl}`);
                    } else {
                        navigate('/cart');
                    }
                } else {
                    if (priviousUrl) {
                        navigate(`${priviousUrl}`);
                    } else {
                        navigate('/');
                    }
                }
            }
            else {
                alert("You have already registered. Please login.");
                Navigate('/login');
            }
        } catch (error) {
            toast.error("Please try again later.");
        } finally {
            setLoading(false);
        }
    }

    const GetUserAddressByLoginId = useCallback(async () => {
        if (loginId) {
            try {
                const response = await get(`${API_URL?.GetUserAddressByLoginId}?pLoginId=${loginId}`);
                const encryptedData = response.data;
                const result = decryptData(encryptedData);
                if (response.isSuccess === 200) {
                    setUserAdderss(result);
                }
            } catch (error) {
                setUserAdderss([]);
            }
        }
    }, [loginId]);

    useEffect(() => {
        GetUserAddressByLoginId();
    }, [GetUserAddressByLoginId]);

    return (
        <Layout>
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            <section className='userlogin'>
                <div className='all_cente_login'>
                    <div className="container">
                        <div className="row justify-content-between user_login_wepper">
                            <div className="col-lg-6 col-md-6 col-12">
                                <div className="left_side_img_data user_login_weppwe_main">
                                    <img src="./images/login_left.png" alt="Hand-stitched chikankari kurta – Gailee" className="w-100" />
                                </div>
                            </div>
                            <div className='col-lg-5 col-md-5 d-flex align-items-center'>
                                <div className='userloginform only_Register'>
                                    <div className='userform-heading'>
                                        <h4>Register</h4>
                                    </div>
                                    <form onSubmit={onRegister}>
                                        <div className="row">
                                            <div className='col-lg-12'>
                                                <input
                                                    name="Name"
                                                    className="form-control"
                                                    required=""
                                                    type="text"
                                                    placeholder="Full Name"
                                                    value={formData.Name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className='col-lg-12'>
                                                <input
                                                    name="EmailId"
                                                    className="form-control"
                                                    required="" type="email"
                                                    placeholder="Email"
                                                    value={formData.EmailId}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className='col-lg-12'>
                                                <input
                                                    type="text"
                                                    name="MobileNo"
                                                    className="form-control"
                                                    placeholder="Mobile Number"
                                                    required=""
                                                    value={formData.MobileNo}
                                                    onChange={handleChange}
                                                    maxLength={10}
                                                />
                                            </div>
                                            <div className='col-lg-12 user-loginbtn'>
                                                <button
                                                    type="submit"
                                                    onClick={onRegister}
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <ClipLoader color="#fff" size={20} />
                                                    ) : (
                                                        'Register'
                                                    )}
                                                </button>
                                            </div>
                                            <div className='userformlinks mt-2'>
                                                <span>Already have an account?</span>
                                                <Link className="register_color" to="/login">Login</Link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default UserRegister;